/**
 * Save a file without opening a window. Bulk actions call this in a loop after
 * awaiting the API, where `window.open` is popup-blocked for every file but the
 * first. The PDF URL is same-origin (`/mdi/p/...`) on deployed hosts; if the
 * fetch itself fails (e.g. a cross-origin URL without CORS locally) it falls
 * back to opening the URL.
 */
export async function saveFile(url: string, fileName: string): Promise<void> {
  let res: Response;
  try {
    res = await fetch(url);
  } catch {
    window.open(url);
    return;
  }
  if (!res.ok) throw new Error(`HTTP ${res.status}`);

  const href = URL.createObjectURL(await res.blob());
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(href), 1000);
}
